import React from "react";
import Head from "next/head";
import { useTranslations } from "next-intl";

import { getLocalePaths } from "utils/getLocalePaths";
import Catalog from "modules/catalog";
import { Breadcrumbs } from "ui/breadcrumbs";
import { buildLink } from "utils/buildLink";
import { getAlternateLinks } from "utils/getAlternateLinks";
import { getLocationInfo } from "utils/getLocationInfo";
import { Catalog as CatalogType, CategoryListScreenSection, getScreenCatalog } from "resources/AudiotekaApi";

export default function CatalogPage({ catalog }: { catalog: CatalogType }) {
  const t = useTranslations();

  return (
    <>
      <Head>{getAlternateLinks("catalog")}</Head>
      <Breadcrumbs items={[{ name: t("breadcrumbs.catalog") }]} />
      <Catalog catalog={catalog} />
    </>
  );
}

export const getStaticProps = async ({ params }) => {
  const { catalogId } = getLocationInfo(params.locale);

  const { data: catalog } = await getScreenCatalog(catalogId);

  catalog._embedded["app:screen-section"] = catalog._embedded["app:screen-section"].map((section) => {
    if (section.type === "category-list") {
      const embedded = {} as CategoryListScreenSection["_embedded"];

      Object.entries(section._embedded).forEach(([key, categories]) => {
        embedded[key] = categories.filter((category) => !category.parent_id);
      });

      return {
        ...section,
        _embedded: embedded,
      };
    }

    return section;
  });

  return {
    props: {
      _canonical: buildLink("catalog", params.locale),
      catalog,
    },
    revalidate: 3600,
  };
};

export async function getStaticPaths() {
  return {
    paths: getLocalePaths(),
    fallback: false,
  };
}
